import api from '@/services/api'
import { useTheme } from 'vuetify'

export const useAppTheme = () => {
    const vuetifyTheme = useTheme()

    const applyTheme = theme => {
        if (!theme) return

        const root = document.documentElement
        const isDark = vuetifyTheme.global.name.value === 'dark'

        // Nav color: si hay color de empresa úsalo, si no adapta al modo
        if (theme.nav_color) {
            root.style.setProperty('--nav-color', theme.nav_color)
        } else {
            // Sin color configurado — deja que --v-theme-surface lo maneje
            root.style.removeProperty('--nav-color')
        }

        if (theme.header_color) root.style.setProperty('--header-color', theme.header_color)

        if (theme.primary_color) {
            vuetifyTheme.themes.value.light.colors.primary = theme.primary_color
            vuetifyTheme.themes.value.dark.colors.primary = theme.primary_color
        }

        localStorage.setItem('appTheme', JSON.stringify(theme))
    }

    const loadTheme = async () => {
        // Aplica cache primero para evitar flash
        const cached = localStorage.getItem('appTheme')
        if (cached) applyTheme(JSON.parse(cached))

        // Sincroniza con backend
        try {
            const { data } = await api.get('/companies/theme')
            if (data.data) applyTheme(data.data)
        } catch { /* silencioso */ }
    }

    return { applyTheme, loadTheme }
}
